/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ resource: NonNullable<unknown>, source: NonNullable<unknown> }} Days_To_DuplicateInputs */



/**
* | resource | output |
* | --- | --- |
* | "airHandlerUnit" | "Days of {source} to duplicate" |
* | "network" | "Days of network {source} to duplicate" |
* | "room" | "Days of room {source} to duplicate" |
* | * | "Days of {source} to duplicate" |
*
* @param {Days_To_DuplicateInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const days_to_duplicate = /** @type {((inputs: Days_To_DuplicateInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Days_To_DuplicateInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Days of ${i?.source} to duplicate`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Days of network ${i?.source} to duplicate`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Days of room ${i?.source} to duplicate`);
		return /** @type {LocalizedString} */ (`Days of ${i?.source} to duplicate`)
	}
	{
		if (i?.resource === "airHandlerUnit") return /** @type {LocalizedString} */ (`Jours de ${i?.source} à dupliquer`);
		if (i?.resource === "network") return /** @type {LocalizedString} */ (`Jours du réseau ${i?.source} à dupliquer`);
		if (i?.resource === "room") return /** @type {LocalizedString} */ (`Jours de la pièce ${i?.source} à dupliquer`);
		return /** @type {LocalizedString} */ (`Jours de ${i?.source} à dupliquer`)
	}
});